import { styled } from "goober";
import { Icon } from "../Icon";
import { Text } from "../Text";
import type { ButtonStyle } from "./buttonStyle";

const IconWrap = styled("span")`
  display: inline-flex;
`;

export function ButtonContent({
  size = "m",
  icon,
  children,
}: Pick<ButtonStyle, "size" | "icon" | "children">) {
  return (
    <>
      {icon && (
        <IconWrap>
          <Icon name={icon} size={size === "l" ? 16 : 12} />
        </IconWrap>
      )}
      {children && (
        <Text variant={size === "l" ? "text-regular-md" : "text-small-md"}>
          {children}
        </Text>
      )}
    </>
  );
}
